<template>
  <b-modal
    :modal-class="`app-modal ${modalClass}`"
    v-bind="$attrs"
    centered
    scrollable
    v-on="$listeners"
  >
    <template v-slot:modal-header-close>
      <b-icon icon="plus" rotate="45" scale="1.3" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </b-modal>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      modalClass: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="scss" src="./AppModal.scss"></style>
